import { render } from '@testing-library/react';
import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { GeoserverGetCapabilities } from '../../services/geoserver/GeoserverCapabilities';
import Meses from '../../services/Meses';
import NoticiasApi from '../../services/robinhood/NoticiasApi';

export default function MenuNoticias() {

  const meses = Meses;
  const [anos, setAnos] = useState([]);
  const [menu, setMenu] = useState(new Date().getFullYear());
  const [menuItem, setMenuItem] = useState(null);

  useEffect(() => {
    start();
  }, [])

  const start = async () => {
    new NoticiasApi().anos().then(response => {
      const anosMap = response.map(ano => ano.ano);
      setAnos(anosMap.reverse());
    });
  }

  const handlerMenu = (ano) => {
    if (menu == ano)
      setMenu(null);
    else
      setMenu(ano);
  }

  const handlerMenuItem = (_item) => {
    setMenuItem(_item);
  }

  const CalalogGroup = (props) => {
    return (
      <>
        <li className={menu == props.ano ? 'active open' : ''}><a onClick={() => handlerMenu(props.ano)} href="javascript:void(0);" className="menu-toggle  waves-effect waves-block"><i className="zmdi zmdi-caret-down"></i><span> {props.ano}</span> </a>
          <ul className="ml-menu" style={{ display: menu == props.ano ? 'block' : 'none' }}>
            <CatalogItem workspace={props.ano} layers={props.layers} />
          </ul>
        </li >
      </>
    );
  }

  const CatalogItem = (props) => {
    return (
      <>
        {meses.map(mes => <li key={Math.random()} className={menu == props.workspace && menuItem == mes.id ? 'active' : ''}> <Link to={'/noticias/periodo'} key={Math.random()} title={mes.mes} state={{ periodo: { 'mes_id': mes.id, 'mes': mes.mes, 'ano': props.workspace }, 'key': Math.random() }} className="waves-effect waves-classic" onClick={() => handlerMenuItem(mes.id)}> <span> {mes.mes} </span> </Link></li>)}
      </>
    );
  }

  return (
    <>
      <div className="menu">
        <ul className="list">
          <li className="header"><strong> <i className='zmdi zmdi-calendar m-r-5'></i>  &nbsp;PERÍODOS DISPONÍVEIS </strong></li>
          {anos.map(ano => {
            return <CalalogGroup key={Math.random()} ano={ano} />
          }
          )}
          {/* <li ><a href="http://robin-hood-historico.fjp.mg.gov.br/index.php/banco-de-noticias" target='_blank' className="waves-effect waves-block"><i className="zmdi zmdi-link"></i><span> DEMAIS ANOS </span> </a></li > */}
        </ul>
      </div>
    </>
  );

}
